module.exports = __webpack_public_path__ + "img/afcft.67b0cbb1.jpg";